<script setup>
import { useMapGetter } from 'dashboard/composables/store.js';

import SearchResultSection from './SearchResultSection.vue';
import SearchResultLostObjectItem from './SearchResultLostObjectItem.vue';

defineProps({
  lostObjects: { type: Array, default: () => [] },
  query: { type: String, default: '' },
  isFetching: { type: Boolean, default: false },
  showTitle: { type: Boolean, default: true },
});

const accountId = useMapGetter('getCurrentAccountId');
</script>

<template>
  <SearchResultSection
    :title="$t('SEARCH.SECTION.LOST_OBJECTS')"
    :empty="!lostObjects.length"
    :query="query"
    :show-title="showTitle"
    :is-fetching="isFetching"
  >
    <ul v-if="lostObjects.length" class="space-y-3 list-none">
      <li v-for="lostObject in lostObjects" :key="lostObject.id">
        <SearchResultLostObjectItem
          :id="lostObject.id"
          :name="lostObject.name"
          :description="lostObject.description"
          :claim-code="lostObject.claimCode"
          :system-stage="lostObject.systemStage"
          :category="lostObject.category"
          :account-id="accountId"
          :updated-at="lostObject.updatedAt"
        />
      </li>
    </ul>
  </SearchResultSection>
</template>
